import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton, MatProgressSpinner],
})
export class DialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<DialogComponent>>(MatDialogRef);
  public data = inject<Model.UploadFileDialogData>(MAT_DIALOG_DATA);

  public activeSpinner: Model.DialogSpinner = {
    mode: Model.ProgressSpinnerMode.Determinate,
    value: 0,
  };
  public filledSpinner: Model.DialogSpinner = {
    mode: Model.ProgressSpinnerMode.Determinate,
    value: 100,
  };

  public ngOnInit(): void {
    if (this.data && this.data['view'] === 'uploadingFile') {
      setTimeout(() => {
        this.activeSpinner.value = 0;
      }, 10000);
      setInterval(() => {
        this.activeSpinner.value = this.activeSpinner.value + 10;
      }, 1000);
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
